import Store from 'store/store';
import * as actions from 'store/actions';
import { getPixelDims } from 'utils/bolt/client';

const fire = (action, cat, label) => {
	gtag('event', action, {
		event_category: cat,
		event_label: label,
	});
};

const firePageView = ({ page }) => {
	gtag('event', 'page_view', {
		page_title: page?.name,
		page_path: page?.path,
	});
	setTimeout(() => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: '3secDwell',
		});
	}, 3000);
};

const fireLanding = ({ page }) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'Landing',
		site: {
			name: page?.name === 'Home' ? 'Homepage' : page?.name,
			market: 'US',
			template: page?.name === 'Home' ? 'Homepage' : page?.name,
		},
		page: {
			name: page?.name === 'Home' ? 'Homepage' : page?.name,
			type: page?.name === 'Home' ? 'Homepage' : page?.name,
		},
		movie: {
			name: null,
			release_date: null,
			imdb_id: null,
			genre: {
				essence_genre: null,
				genre_1: null,
				content_genome: 'N/A',
				fs_o: undefined,
			}
		}
	});
};

Store.on(actions.LANDING, (data) => {
	fireLanding(data);
	firePageView(data);
	fire('landing');
	fire('timing_complete');

	const pixelDims = getPixelDims();
	fire('screen-pixel-dimensions', '', `${pixelDims.width}x${pixelDims.height}`);

	const client = Store.get().client;
	fire('location_origin', '', client.geo.countryCode);
});

Store.on(actions.ACTIVE_PAGE_UPDATED, firePageView);

/** Menu */
Store.on(actions.HEADER_PERSISTENT_BUTTON_CLICK, label => fire('header_nav_click', '', label));
Store.on(actions.FOOTER_NAV_CLICK, label => fire('footer_nav_click', '', label));
Store.on(actions.FOOTER_LEGAL_CLICK, ({ label, path }) => fire('footer_legal_click', { label, url: path }));

/** Social Events */
Store.on(actions.CLICKED_FOLLOW, ({ type, id, url }) => {
	if (type === 'header') {
		fire('header_social_follow', '', id);
	}
	if (type === 'footer') {
		fire('footer_social_follow', '', id);
	}
	if (type === 'subscribe') {
		fire('subscribe_social_follow', '', id);
	}
});

/** Landing - Hero */
Store.on(actions.HERO_BUTTON_CLICK, ({ title, label }) => fire('hero_button_click', '', `${title} - ${label}`));
Store.on(actions.HERO_MOVIE_SELECTION_TAB_CLICK, ({ title }) => fire('hero_tab_click', '', title));
Store.on(actions.HERO_TAB_DIRECTION_CLICK, ({ direction }) => fire('hero_slides_engagement', '', `hero - ${direction}`));
Store.on(actions.HERO_VIDEO_SLIDE_PLAY_TOGGLE, ({ state, count }) => fire('hero_play_slides', '', `${state ? 'play' : 'pause'}_${count}`));


Store.on(actions.ABOUT_SCROLL, ({ percentage }) => fire('about_scroll', '', percentage));
Store.on(actions.ABOUT_VIDEO_SLIDE_PLAY_TOGGLE, ({ state }) => fire('about_video_play_click', '', state ? 'play' : 'pause'));
Store.on(actions.ABOUT_VIDEO_SLIDE_MUTE_TOGGLE, ({ state }) => fire('about_video_volume_click', '', state ? 'mute' : 'unmute'));

Store.on(actions.NEWS_ARTICLE_CLICK, ({ title }) => fire('article_click', '', title));

Store.on(actions.FUTURE_RELEASE_DATE_CLICK, ({ title }) => fire('future_release_click', '', title));

/** Carousel */
Store.on(actions.CAROUSEL_TOUT_CLICK, ({ title }) => fire('carousel_tout_click', '', title));
Store.on(actions.CAROUSEL_BUTTON_CLICK, ({ title, label }) => fire('carousel_button_click', '', `${title} - ${label}`));
Store.on(actions.CAROUSEL_TAB_DIRECTION_CLICK, ({ direction }) => fire('carousel_engagement', '', `carousel - ${direction}`));

Store.on(actions.MOVIELINK_TITLE_LINK_CLICK, ({ title }) => {
	if (title === 'Future Releases Click') {
		fire('future_releases_click', '', title);
		return;
	}
	fire('movie_link_click', '', title);
});

/** Video's/Movies Section */
Store.on(actions.STUDIO_YOUTUBE_CHANNEL_CLICK, ({ title }) => fire('trailers_youtube_click', '', title));
Store.on(actions.TRAILERS_TOUT_CLICK, ({ title }) => fire('trailer_tout_click', '', title));
Store.on(actions.TRAILERS_TAB_DIRECTION_CLICK, ({ direction }) => fire('trailers_engagement', '', `videos - ${direction}`));
Store.on(actions.TRAILER_MORE_INFO_CLICK, ({ title }) => fire('trailer_info_click', '', title));

Store.on(actions.PROMO_TOUT_CLICK, ({ title }) => fire('promo_tout_click', '', title));
Store.on(actions.PROMO_VIDEO_SLIDE_PLAY_TOGGLE, ({ state, count }) => fire('promo_play_click', '', `${state ? 'play' : 'pause'}_${count}`));

Store.on(actions.FORM_SUBMIT_CLICK, () => fire('subscribe_click', '', `${'NEWSLETTER'} Subscribe`));